import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "../lib/api";

const boxCls = "flex items-start gap-3 text-left";
const checkCls =
  "mt-0.5 h-5 w-5 shrink-0 rounded border-zinc-300 text-zinc-900 focus:ring-zinc-950 accent-zinc-900";

// Aceptación legal pendiente para empresas existentes (piloto): la exige el administrador
// de la empresa dentro de la app. No afecta al área /platform (fuera de este Layout).
export default function LegalGate({ user }) {
  const [status, setStatus] = useState(null);
  const [terms, setTerms] = useState(false);
  const [dpa, setDpa] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user) return;
    api
      .get("/legal/status")
      .then(({ data }) => setStatus(data))
      .catch(() => setStatus({ terms_accepted: true, dpa_accepted: true }));
  }, [user]);

  if (!user || user.role !== "admin" || !status) return null;
  if (status.terms_accepted && status.dpa_accepted) return null;

  const submit = async () => {
    setSaving(true);
    try {
      await api.post("/legal/accept", { accept_terms: terms, accept_dpa: dpa });
      setStatus({ ...status, terms_accepted: true, dpa_accepted: true });
      toast.success("Aceptación registrada");
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] bg-zinc-950/40 backdrop-blur-sm flex items-center justify-center p-4"
      data-testid="legal-gate-modal"
    >
      <div className="bg-white rounded-3xl border border-zinc-200/80 card-shadow max-w-lg w-full p-7 sm:p-8 animate-fade-up">
        <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-3">
          Documentación legal del piloto
        </p>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-zinc-950">
          Aceptación pendiente
        </h2>
        <p className="text-sm text-zinc-600 leading-relaxed mt-3">
          Antes de continuar usando Asset Passport, el administrador de la organización debe
          revisar y aceptar la documentación legal del piloto B2B.
        </p>
        <div className="mt-5 space-y-4">
          <label className={boxCls}>
            <input
              type="checkbox"
              className={checkCls}
              checked={terms}
              onChange={(e) => setTerms(e.target.checked)}
              data-testid="legal-gate-terms-checkbox"
            />
            <span className="text-sm text-zinc-700 leading-relaxed">
              He leído y acepto los{" "}
              <a href="/terms" target="_blank" rel="noreferrer" className="underline underline-offset-2">
                Términos y condiciones de uso
              </a>{" "}
              y confirmo que actúo en nombre de una empresa o en calidad profesional. He leído la{" "}
              <a href="/privacy" target="_blank" rel="noreferrer" className="underline underline-offset-2">
                Política de privacidad
              </a>
              .
            </span>
          </label>
          <label className={boxCls}>
            <input
              type="checkbox"
              className={checkCls}
              checked={dpa}
              onChange={(e) => setDpa(e.target.checked)}
              data-testid="legal-gate-dpa-checkbox"
            />
            <span className="text-sm text-zinc-700 leading-relaxed">
              En nombre de mi organización, acepto el{" "}
              <a href="/dpa" target="_blank" rel="noreferrer" className="underline underline-offset-2">
                Acuerdo de Encargo del Tratamiento (DPA)
              </a>{" "}
              aplicable cuando Asset Passport trate datos personales por cuenta de la organización.
            </span>
          </label>
        </div>
        <button
          onClick={submit}
          disabled={!terms || !dpa || saving}
          data-testid="legal-gate-submit"
          className="mt-6 w-full h-12 rounded-full bg-zinc-900 text-white font-medium hover:bg-zinc-800 active:scale-[0.98] transition-[background-color,transform] duration-200 disabled:opacity-50"
        >
          {saving ? "Registrando…" : "Aceptar y continuar"}
        </button>
      </div>
    </div>
  );
}
